import { render, staticRenderFns } from "./failure-complete.vue?vue&type=template&id=2914f036&scoped=true"
import script from "./failure-complete.vue?vue&type=script&lang=js"
export * from "./failure-complete.vue?vue&type=script&lang=js"
import style0 from "./failure-complete.vue?vue&type=style&index=0&id=2914f036&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2914f036",
  null
  
)

export default component.exports